<!-- 汇率查询 -->
<template>
  <div class="orderSearch">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @searchCompanyChange="searchCompanyChange"
      @searchOrderChange="searchOrderChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <span v-if="reserve">选中{{ multipleSelection.length }}条</span>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-rules="rules"
        :checkbox-config="{ reserve: reserve }"
        row-id="id"
        :max-height="$store.state.app.tableHeight"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-actived="editActivedEvent"
        :show-footer="showFooter"
        :footer-method="footerMethodTotal"
      >
        <!--  <vxe-table-column
          v-for="(item,index) in columnList"
          v-bind="item"
          :key="index"
          :width="item.width || 120"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field]|getDictNameByCode(item.dictType)}}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field]|formatTableColumn(item.format)}}
            </span>
            <span v-else>{{scope.row[item.field]}}</span>
          </template>
        </vxe-table-column> -->
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/moneyDraw';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiUpload from '@/components/SiruiUpload';
  // import COM_API from '@/api/masterData/company.js';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'orderSearch',
    components: {
      SiruiSearch,
      SiruiUpload,
    },
    props: [
      'searchColumns',
      'searchForm',
      'columnList',
      'api',
      'rules',
      'addPath',
      'type',
      'reserve',
      'showFooter',
      'footerTotalCols',
    ],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      action() {
        return API[this.api.import];
      },
      exportAction() {
        return API[this.api.export];
      },
    },
    data() {
      return {
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        interestStatusOption: [
          { value: 'N', label: '未计息' },
          { value: 'Y', label: '已计息' },
          { value: 'E', label: '异常计息' },
        ],
      };
    },
    mounted() {
      if (Object.keys(this.$route.query).length == 0) {
        this.getData();
      }
      this.getButtonList();
    },
    methods: {
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.page;
        let params = { ...this.searchForm, pageNum, pageSize };
        if (params.orderDepartmentCodes) {
          params.orderDepartmentCodes = params.orderDepartmentCodes.split(',');
        }
        if (params.interestGroupCodes && XEUtils.isArray(params.interestGroupCodes))
          params.interestGroupCodes = params.interestGroupCodes.join(',');
        let res = await this.$axios.post(API[this.api.query], params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
            this.updateData();
          }
        }
      },
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'edit') {
          this.handleEdit();
        } else if (value === 'save') {
          this.handleSave();
        } else if (value == 'import') {
          this.$refs.SiruiUpload.dialogUpload = true;
        } else if (value == 'del') {
          this.handleDel();
        } else if (value == 'export') {
          this.handleExport();
        } else if (value == 'calculate') {
          // 重新计息
          this.handleCalculate();
        }
      },
      handleCalculate() {
        // 重新计息
        if (this.multipleSelection.length != 1) {
          return this.tips('onlyOneSelectData');
        }
        if (this.multipleSelection[0].interestStatus == 'Y') {
          return this.tips('noCanCal');
        }
        this.$axios.post(API[this.api.cal], { id: this.multipleSelection[0].id }).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.table.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = XEUtils.clone(this.searchForm, true);
          if (params.interestGroupCodes && XEUtils.isArray(params.interestGroupCodes))
            params.interestGroupCodes = params.interestGroupCodes.join(',');
          params = XEUtils.serialize(params);
          window.location.href = `${baseUrl}${this.exportAction}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 跳转至新增页面
      handleAdd() {
        this.$store.dispatch('tagsView/addTabView', this.addPath).then(() => {
          this.$nextTick(() => {
            this.$router.push(this.addPath);
          });
        });
      },
      // 编辑
      handleEdit() {
        let selectRecords = this.$refs.table.getCheckboxRecords();
        let row = selectRecords[0];
        this.$refs.table.setActiveRow(row);
        // return
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.$message({
            showClose: true,
            message: this.$t('interOrderPool.message.select'),
            type: 'error',
          });
        }
      },
      async handleSave() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API[this.api.save], params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.resetBtnClick();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      activeRowMethod({ row }) {
        if (this.type == 'cash') {
          if (row.modifyAllowed == 'N') {
            return false;
          }
        } else {
          if (row.originFlag == 'A') {
            return false;
          }
        }
        return true;
      },
      editActivedEvent({ row }) {
        this.$emit('editActivedEvent', row);
      },
      // 选中事件
      handleSelectionChange(val) {
        // 当允许翻页时，勾选checkbox需要将历史记录合并
        let allChecked =
          this.$refs.table.getCheckboxReserveRecords()[0] && this.reserve
            ? this.$refs.table.getCheckboxReserveRecords().concat(val.selection)
            : val.selection;
        this.multipleSelection = allChecked;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      searchCompanyChange(val) {
        this.$emit('searchCompanyChange', val.val);
      },
      searchOrderChange(val) {
        this.$emit('searchOrderChange', val.val);
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.$refs.table.clearCheckboxReserve();
        this.$refs.table.clearCheckboxRow();
        this.multipleSelection = [];
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected');
        }
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (i.originFlag == 'M') {
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips('noCanDelSelectData');
        }
        let items = canDelitems.map((i) => i.id);
        let message = null;
        if (canDelitems.length !== this.multipleSelection.length) {
          message = this.$t('interOrderPool.message.hasCannotDelTip');
        }
        this.$confirmAction(this.$t('confirm.delete'), message)
          .then(() => {
            this.del(items);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        const params = {
          ids,
        };
        this.$axios.post(API[this.api.del], params).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              tableData.map((item) => {
                item.isEnabled = item.isEnabled ? '1' : '0';
              });
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`interOrderPool.message.${info}`),
          type: 'error',
        });
      },

      // 通用底部合计总数 - footerTotalCols定义在各个具体文件中，示例如下
      // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']}, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点

      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = XEUtils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = XEUtils.commafy(XEUtils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
    },
  };
</script>
